



import React, { useEffect, useState } from 'react';
import { Link, useNavigate, NavLink } from 'react-router-dom';

import DropdownButton from 'react-bootstrap/DropdownButton'
import './Header.css'
// import { Button,Dropdown} from 'react-bootstrap';
import { Button, Navbar, Dropdown, Container, Nav, Form, FormControl, NavDropdown } from 'react-bootstrap';
import { useUserAuth } from '../../contexts/UserAuthContext'

import Spinner from 'react-bootstrap/Spinner';
import logo from "../images/logo_lakshyaved.jpeg";


function Header(props) {

  let time = new Date().toLocaleTimeString();
  const [ctime, setCtime] = useState(time);

  const UpdateTime = () => {
    time = new Date().toLocaleTimeString();
    setCtime(time);
  };

  setInterval(UpdateTime, 1000);



  const navigate = useNavigate()
  const { user, logOut } = useUserAuth()
  const [photoURL, setPhotoURL] = useState()

  //const emailVerified = user.emailVerified;
  const handleLogOut = async () => {
    try {
      await logOut()
      window.location.reload()
      navigate("/")
    } catch (err) {

    }
  }

  useEffect(() => {
    if (user?.photoURL) {
      setPhotoURL(user.photoURL)
    }

  }, [user])


  return (
    <>
      {/* <div className="mains container-fluid"> */}
      <div className="fixed-top">
    

        <Navbar bg="white shadow" expand="lg">
          <Container fluid>
            <Navbar.Brand>
              <Link to="/" className=''>
              <div className='radious'>
               <img src={logo}  height="60px" width="145px" alt='logo'/>
                </div>
              </Link>

            </Navbar.Brand>
            <div className="text-end d-grid gap-2 d-md-flex justify-content-md-end">

{!user ? (

  <div>

    <Link to="/Login">
      <button type="button" className="buttonlogin me-0"> <small> Admin</small></button>
    </Link>

  </div>
) :
  <>

    <Dropdown className='dropdown'>
      <Dropdown.Toggle variant="none" id="dropdown-basic">
        <img className='userphoto' src={user.photoURL} alt=""/>
      </Dropdown.Toggle>

      <Dropdown.Menu>
       
          <Dropdown.Item>
            <Button onClick={() => { navigate(`/UserDashboard/${user.uid}`) }} variant='secondary btn-sm'><small>Dashboard</small></Button>
          </Dropdown.Item>
         
          <Dropdown.Item>
            <Button onClick={() => { navigate(`/UserDashboard/${user.uid}`) }} variant='light btn-sm'>Upload  </Button>
          </Dropdown.Item>
          <Dropdown.Item>
            <Button variant='danger btn-sm' onClick={handleLogOut}><small>LOG OUT</small></Button>
          </Dropdown.Item>
        
      </Dropdown.Menu>

    </Dropdown>
  </>

}

</div>

            <Navbar.Toggle aria-controls="navbarScroll" />
            <Navbar.Collapse id="navbarScroll">
              <Nav
                className="mx-auto my-2 my-lg-0"
                style={{ maxHeight: '290px' }}
                navbarScroll
              >

               <li className="nav-item">
                        <div className='colornav'>
                        <Link to="/" className="nav-link " aria-current="page" href="#">HOME</Link>
                        </div>
                      </li>
                      <li className="nav-item">
                      <div className='colornav'>
                        <Link to="/About-us" className="nav-link" href="#">ABOUT</Link>
                        </div>
                      </li>
              
                      <li className="nav-item">
                      <div className='colornav'>
                        <Link to="/services" className="nav-link" href="#">SERVICES</Link>
                        </div>
                      </li>
                     
                      <li className="nav-item">
                      <div className='colornav'>
                        <Link to="/Courses" className="nav-link" href="#">COURSES</Link>
                        </div>
                      </li>
                      <li className="nav-item">
                      <div className='colornav'>
                        <Link to="/" className="nav-link" href="#">CLIENTS & MISCELLANEOUS </Link>
                        </div>
                      </li>
                      <li className="nav-item">
                      <div className='colornav'>
                        <Link to="/contact-appointment" className="nav-link" href="#">CONTACT & APPOINTMENT </Link>
                        </div>
                      </li>


             














              </Nav>
{/* <a  className='me-2' href='tel: +91 9733966161'>Technicale Helpline </a> */}
 <a href='mailto: 123suman2020@gmail.com'>
        <button className="btnnav" type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-paper" viewBox="0 0 16 16">
  <path d="M4 0a2 2 0 0 0-2 2v1.133l-.941.502A2 2 0 0 0 0 5.4V14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5.4a2 2 0 0 0-1.059-1.765L14 3.133V2a2 2 0 0 0-2-2zm10 4.267.47.25A1 1 0 0 1 15 5.4v.817l-1 .6zm-1 3.15-3.75 2.25L8 8.917l-1.25.75L3 7.417V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1zm-11-.6-1-.6V5.4a1 1 0 0 1 .53-.882L2 4.267zm13 .566v5.734l-4.778-2.867zm-.035 6.88A1 1 0 0 1 14 15H2a1 1 0 0 1-.965-.738L8 10.083zM1 13.116V7.383l4.778 2.867L1 13.117Z"/>
</svg> Mail Helpline</button>
        </a>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>

    </>

  );
}

export default Header;



